<template>
    <div id="alert">
        <v-snackbar
            v-if="$store.state.error.options.type"
            v-model="$store.state.error.popAlert"
            top
            light
            :timeout="4000"
            elevation="1"
            class="ma-2"
            content-class="px-0 py-1"
            :color="
                $store.state.error.options.type === 'success'
                    ? 'backgroundGreen'
                    : $store.state.error.options.type === 'error'
                      ? 'errorRed'
                      : 'transparent'
            "
            app
        >
            <v-container fluid class="pa-0 ma-0" three-line color="transparent">
                <v-layout align-center fill-height class="pa-0 ma-0">
                    <v-flex shrink class="mt-0 py-1 px-2">
                        <v-layout align-center fill-height class="mr-1">
                            <v-flex class="pa-0">
                                <svg
                                    v-if="
                                        $store.state.error.options.type ===
                                        'success'
                                    "
                                    width="4"
                                    height="36"
                                    viewBox="0 0 4 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2V34C4 35.1046 3.10457 36 2 36C0.895431 36 0 35.1046 0 34V2Z"
                                        fill="#27AE60"
                                    />
                                </svg>

                                <svg
                                    v-if="
                                        $store.state.error.options.type ===
                                        'error'
                                    "
                                    width="4"
                                    height="36"
                                    viewBox="0 0 4 36"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2V34C4 35.1046 3.10457 36 2 36C0.895431 36 0 35.1046 0 34V2Z"
                                        fill="#DF6767"
                                    />
                                </svg>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex shrink class="mt-0 py-1">
                        <v-layout align-center fill-height class="mr-3">
                            <v-flex
                                v-if="
                                    $store.state.error.options.type ===
                                    'success'
                                "
                                class="pa-0"
                            >
                                <v-icon color="darkGreen"
                                    >mdi-check-circle</v-icon
                                >
                            </v-flex>
                            <v-flex
                                v-if="
                                    $store.state.error.options.type === 'error'
                                "
                                class="pa-0"
                            >
                                <v-icon color="redLight"
                                    >mdi-close-circle</v-icon
                                >
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex class="my-1 py-1">
                        <v-layout column>
                            <v-flex
                                class="roboto-text roboto-500"
                                style="font-size: 14px; color: #333333"
                            >
                                {{ $store.state.error.options.message }}
                            </v-flex>
                            <v-flex
                                v-if="
                                    !$store.state.error.isOffline &&
                                    $store.state.error.options.submessage
                                "
                                class="roboto-text font-weight-400"
                                style="font-size: 12px; color: #666666"
                            >
                                <v-layout wrap>
                                    <v-flex>
                                        {{
                                            $store.state.error.options
                                                .submessage
                                        }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>

            <template v-slot:action="{ attrs }">
                <v-btn small icon text v-bind="attrs" @click="closeAlert()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: "Alert",

    props: ["isError", "message"],

    methods: {
        closeAlert() {
            this.$store.commit("closeAlert", { message: null, type: null });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Alert.vue?9ce99bb6